/* eslint-disable import/prefer-default-export */

export const SWIPER_PAGINATION = 'swiperWithPagination';
